<table mat-table [dataSource]="props" class="propsTable">
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Описание</th>
    <td mat-cell *matCellDef="let prop">{{ prop.property.description }}</td>
  </ng-container>
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>Значение</th>
    <td mat-cell *matCellDef="let prop">{{ prop.value }}</td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="addProp()">
        <mat-icon>add</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let prop">
      <div class="btnWrapper">
        <button mat-icon-button color="primary" (click)="updateProp(prop)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="removeProp(prop)">
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
</table>
